export default __webpack_public_path__ + "c90438f596895ae89850258870483e7e.png";